import React from 'react';
import styled from 'styled-components';
import { FLEX_DATES } from './constants';

export type FlexDatesPickerProps = {
  className?: string;
  onChangeShift: (shift: number) => void;
  currentShift: number;
};

export const FlexDatesPicker = ({
  onChangeShift,
  currentShift,
  className,
}: FlexDatesPickerProps): JSX.Element => {
  if (!FLEX_DATES.find(({ shiftValue }) => shiftValue === currentShift)) {
    throw new Error('В компонент FlexDatesPicker передана не зарегистрированная флексовая дата');
  }

  return (
    <Container className={className}>
      {FLEX_DATES.map(
        ({ title, shiftValue }): JSX.Element => (
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              onChangeShift(shiftValue);
            }}
            key={shiftValue}
            $isActive={shiftValue === currentShift}
          >
            {title}
          </Button>
        )
      )}
    </Container>
  );
};

const Container = styled.span`
  display: flex;
  justify-content: space-around;
  & > button + button {
    margin-left: 8px;
  }
`;

const Button = styled.button<{ $isActive?: boolean }>`
  padding: 8px;
  height: 100%;
  border-radius: 4px;
  border: 1px solid ${({ $isActive }) => ($isActive ? '#F8E71C' : '#c2c5cc')};
  background-color: ${({ $isActive }) => ($isActive ? '#FFFBE5' : 'inherit')};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  cursor: pointer;
`;
